module.exports = __webpack_public_path__ + "static/media/testing.d583cc0c.png";